import Unified from "./unified";
import { GSPINVESCO } from "~/assets/tenants";
import { unref } from "vue";

export default class DataLoader {
  constructor(args) {
    this.envCustomer = args.hostEnv.customer;

    this.unified = new Unified(args);
  }

  getCustomerName() {
    switch (this.envCustomer) {
      case GSPINVESCO:
        return this.unified.getCustomerName();

      default:
        return this.unified.getCustomerName();
    }
  }

  getUserProfile() {
    switch (this.envCustomer) {
      case GSPINVESCO:
        return this.unified.getUserProfile();

      default:
        return this.unified.getUserProfile();
    }
  }

  getBankList() {
    switch (this.envCustomer) {
      case GSPINVESCO:
        return this.unified.getBankList();

      default:
        return this.unified.getBankList();
    }
  }

  getStateList() {
    switch (this.envCustomer) {
      case GSPINVESCO:
        return this.unified.getStateList();

      default:
        return this.unified.getStateList();
    }
  }

  deleteBank(bankData) {
    bankData = unref(bankData);
    switch (this.envCustomer) {
      case GSPINVESCO:
        return this.unified.deleteBank(bankData);

      default:
        return this.unified.deleteBank(bankData);
    }
  }

  addBank(bankData) {
    bankData = unref(bankData);
    switch (this.envCustomer) {
      case GSPINVESCO:
        return this.unified.addBank(bankData);

      default:
        return this.unified.addBank(bankData);
    }
  }

  getCommPrefCustomer() {
    ///getCommPrefCustomer and getCommPrefTRACCustomer having same property...so written single function
  }

  getAddressList() {}

  getPhoneList() {}

  addPhoneNumber() {}

  addContact() {}

  deletePhoneNumber() {}

  deleteContact() {}

  getCommPrefCustomer() {
    ///getCommPrefCustomer and getCommPrefTRACCustomer having same property...so written single function
  }

  getOperatorUserProfileForRetail() {
    //getUserProfile having same property
  }

  resendCode() {}

  sendCode() {}

  updateAccAddress() {}

  updateCiamProfile() {}

  updateTACommPrefCustomer() {}

  updateTRACCommPrefCustomer() {}

  updatePhoneNumber() {}

  verifyMailingAddress() {}

  verifyResidentialAddress() {}
}
